module.exports = __webpack_public_path__ + "static/img/edit1.cb87f7ea.png";